module.exports = __webpack_public_path__ + "870cb20ca30f9afa9301cbc3d94e901d.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Balzano.woff2?v=1.00
// module id = 935
// module chunks = 24